
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ExperienceSection from './components/ExperienceSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0d1a2a]">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ExperienceSection />
      <ReviewsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
